import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import Loader from './Loader/Loader';

export const AuthenticationGuard = ({
  component: Component
}: {
  component: React.ComponentType;
}) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void loginWithRedirect({
        appState: {
          returnTo: `${window.location.pathname}${window.location.search}`
        }
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading || !isAuthenticated) {
    return <Loader />;
  }

  return <Component />;
};
